import bannerTournoi from '../assets/images/img-banner-tournoi.png';

const imgBannerTournoi = () => {
  return (
    <div
        className="h-96 bg-cover bg-center"      
      style={{ backgroundImage: `url(${bannerTournoi})` }}
    >           
    </div>
  );
};

export default imgBannerTournoi;
